import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { login } from '../api';
import AuthLayout, { Field, Alert, inputClass, primaryBtnClass } from '../components/AuthLayout';
import PasswordInput from '../components/PasswordInput';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const resetDone = location.state?.reset;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await login(email, password);
      const { access_token, admin_email, admin_name, is_admin } = response.data;
      localStorage.setItem('admin_token', access_token);
      localStorage.setItem('admin_email', admin_email);
      localStorage.setItem('admin_name', admin_name);
      localStorage.setItem('admin_is_admin', is_admin ? 'true' : 'false');
      // Clear stale org context so OrgSwitcher re-selects based on the new
      // user's default_org_id rather than keeping a previous session's org.
      localStorage.removeItem('active_org_id');
      localStorage.removeItem('active_org_name');
      localStorage.removeItem('active_org_role');
      navigate(is_admin ? '/dashboard' : '/organizations', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Sign in to your LatentStack account"
      footer={<>Don't have an account? <Link to="/signup" className="font-medium text-orange hover:underline">Sign up</Link></>}
    >
      <form onSubmit={handleSubmit}>
        {resetDone && <Alert kind="success">Password updated. Sign in with your new password.</Alert>}
        <Alert>{error}</Alert>

        <Field label="Email">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputClass}
            placeholder="you@company.com"
            autoComplete="email"
            required
          />
        </Field>

        <div className="mb-5">
          <div className="flex items-center justify-between mb-1.5">
            <label className="block text-[13px] font-medium text-fg">Password</label>
            <Link to="/forgot-password" className="text-[13px] text-orange hover:text-orange-hover transition-colors">
              Forgot password?
            </Link>
          </div>
          <PasswordInput
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            autoComplete="current-password"
          />
        </div>

        <button type="submit" disabled={loading} className={primaryBtnClass}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </AuthLayout>
  );
}

export default Login;
